/**
 * Section — vertical band wrapper used by every marketing section.
 * Standardises max-width, padding, and the eyebrow / title / subtitle header.
 */
import React from 'react';
import { COLOR, FONT } from '../../../components/ss/tokens';

export default function Section({
  id,
  background = '#ffffff',
  eyebrow,
  title,
  subtitle,
  align = 'center',
  children,
  paddingY = 96,
  innerMaxWidth = '100%',
}) {
  return (
    <section
      id={id}
      className="hhms-marketing-section"
      style={{
        background,
        padding: `${paddingY}px 56px`,
        scrollMarginTop: 80,
      }}
    >
      <style>{`
        @media (max-width: 640px) {
          .hhms-marketing-section { padding-left: 20px !important; padding-right: 20px !important; }
        }
      `}</style>
      <div style={{ maxWidth: innerMaxWidth, margin: '0 auto' }}>
        {(eyebrow || title || subtitle) && (
          <header
            data-reveal
            style={{
              textAlign: align,
              marginBottom: 56,
              maxWidth: align === 'center' ? 760 : '100%',
              marginLeft:  align === 'center' ? 'auto' : 0,
              marginRight: align === 'center' ? 'auto' : 0,
            }}
          >
            {eyebrow && (
              <div
                style={{
                  fontSize: FONT.size.sm,
                  fontWeight: FONT.weight.bold,
                  color: COLOR.blue,
                  textTransform: 'uppercase',
                  letterSpacing: '1.6px',
                  marginBottom: 14,
                }}
              >
                {eyebrow}
              </div>
            )}
            {title && (
              <h2
                style={{
                  margin: 0,
                  fontSize: 36,
                  lineHeight: 1.18,
                  fontWeight: FONT.weight.xbold,
                  color: COLOR.text,
                  letterSpacing: '-0.4px',
                }}
              >
                {title}
              </h2>
            )}
            {subtitle && (
              <p
                style={{
                  marginTop: 18,
                  marginBottom: 0,
                  fontSize: 17,
                  lineHeight: 1.6,
                  color: COLOR.textMuted,
                }}
              >
                {subtitle}
              </p>
            )}
          </header>
        )}
        {children}
      </div>
    </section>
  );
}
